(ns fablo-offers.app.components.app
  (:require ["@chakra-ui/react" :as ch]
            ["@emotion/react" :as emotion]
            ["@iconify/react" :as iconify]
            ["@uselessdev/datepicker" :as calendar]
            ["framer-motion" :as fm]
            ["react" :as react]
            ["@chakra-ui/anatomy" :refer [inputAnatomy]]
            [cljs-bean.core :refer [->clj ->js] :as bean]
            [clojure.string :as string]
            [fablo-offers.common.components.language-selector :as language-selector]
            [fablo-offers.common.lib.hooks :as hooks]
            [fablo-offers.common.lib.routing :as routing]
            [fablo-offers.common.state :as s]
            [fablo-offers.common.tracking :as tracking]
            [rumext.alpha :as mf]
            [shadow.loader :as loader]
            [tick.core :as tick]))

(def tpay-logo "https://tpay.com/img/banners/tpay_logo_blue.svg")

(def route-state
  (s/atom nil))

(def next-transition (volatile! :init)) ; :forward :back, :bottom

(s/debug-label route-state "route-state")

(def components (atom {}))

(def route-tracking-params [:offer-id :provider-id :order-id :payment-id :screen])

(defn track-route-params! [route-params]
  (tracking/register
   (->> (select-keys route-params route-tracking-params)
        (filter second)
        (into {})))
  (doseq [p (remove #(get route-params %) route-tracking-params)]
    (tracking/unregister (name p))))

(def screen-state
  (s/api-atom
   [] ;[:current-screen]
   (fn [get]
     (let [route-params (get route-state)
           screen-name (:screen route-params)
           params (dissoc route-params :screen)]
       (track-route-params! route-params)
       [screen-name params]))))

(s/debug-label screen-state "screen-state")

(def last-resolved-state (s/atom nil))

(mf/defc with-last-resolved-state [_]
  (let [state (s/use-atom screen-state)
        last-state (s/use-atom last-resolved-state)]
    (mf/with-effect
      [@state]
      (reset! last-state @state))))

(mf/defc footer [props]
  (let [{:keys [t]} (hooks/use-translation)]
    [:> ch/Container {}
     [:> ch/VStack
      {:color :gray.500
       :font-size :sm
       :py 6
       :spacing 6}
      [:> ch/HStack {:w :full :justify :space-between}
       [:> ch/Text {}
        (t :footer/operated-by)
        [:> ch/Link {:href "//fablo.eu" :target :_blank}
         [:> ch/Image {:src "/img/logo.png" :h 5 :display :inline}]
         [:> ch/Text {:as "b" :font-weight 500}  " Fablo"]]]
       [:> ch/Text {}
        (t :footer/payments-by)
        [:> ch/Link {:href "https://tpay.com" :target :_blank}
         [:> ch/Image {:src tpay-logo :display :inline :h 4}]]]]
      [:> ch/HStack {:w :full :justify :space-between}
       [:> ch/Text {}
        [:> ch/Link {:href "/fablo" :target :_blank}
         (t :footer/terms)]]
       [:> ch/Text {} "© 2026 FABLO"]]]]))

(defn input-theme []
  (let [{:keys [definePartsStyle defineMultiStyleConfig]} (->clj (ch/createMultiStyleConfigHelpers (.-keys inputAnatomy)))
        outline
        (definePartsStyle
          (->js
           {:field
            {:borderColor "border-primary.500"}}))]
    (defineMultiStyleConfig
      (->js {:variants {:outline outline}}))))

(defn theme [theme-cfg]
  (let [colors (merge
                {:border-primary {:500 "#F95640"}
                 :surface-primary {:500 "#F95640"}
                 :border-secondary {:500 "#5BAA99"}
                 :surface-secondary {:200 "#D8EFE8"}}
                (:colors theme-cfg))
        colors (assoc-in colors [:brand :500] (:brand-color theme-cfg "#3182CE"))
        colors (assoc-in colors [:border-primary :600]
                         (or (get-in colors [:border-primary :600]) (get-in colors [:border-primary :500])))]

    (ch/extendTheme
     calendar/CalendarDefaultTheme
     (clj->js
      {:fonts
       {:heading (str (some-> (get-in theme-cfg [:fonts :heading]) (str ", "))
                      "'Abhaya Libre', sans-serif")
        :body (str (some-> (get-in theme-cfg [:fonts :body]) (str ", "))
                   "'Raleway', sans-serif")}
       :colors colors
       :components
       {:Heading
        {:baseStyle
         {:color "border-primary.500"}}
        :Button
        {:variants {}}
        "CalendarDay"
        {:variants
         {:selected
          {:bgColor "blue.400"
           :_hover {:bgColor "blue.300"}}}}
        :Radio
        {:defaultProps {:colorScheme "border-primary"}}
        :Checkbox
        {:defaultProps {:colorScheme "border-primary"}}
        :Input (input-theme)
        :Textarea
        {:variants {:outline {:borderColor "border-primary.500"}}}}}))))

(mf/defc fonts-import [{:keys [fonts-css-import]}]
  [:> emotion/Global
   {:styles fonts-css-import}])

(mf/defc header-bar [{:keys [provider without-navigation?]}]
  (let [business-info (:provider/business-info provider)
        route (s/use-atom route-state)
        home-offer-id (:home-offer-id business-info)
        home-page? (and
                    (= (:screen @route) :screen/offer)
                    (or (nil? (:offer-id @route))
                        (= (:offer-id @route) home-offer-id)))
        home-href (routing/href :screen/offer-main
                                (-> @route
                                    (dissoc :offer-id)
                                    (assoc :provider-id (:provider/id provider))))
        home-href (if (and home-page? (= (:provider/id provider) "riverview"))
                    "/intercontinental" ;; fixme
                    home-href)
        without-navigation? (or without-navigation? (:f @route))]
    [:> ch/Flex
     {:align :center
      :p 4
      :justify :space-between
      :position (when-not without-navigation? "sticky")
      :shadow :sm
      :top 0
      :bg "white"
      :z-index 10}
     (if without-navigation?
       [:> ch/Box {:w "64px"}]
       [:> ch/Link
        {:href (str home-href "?c=1")}
        [:> ch/Button
         {:variant :ghost}
         [:& iconify/Icon
          {:icon "material-symbols:home-outline-rounded"
           :color "var(--chakra-colors-gray-600)"
           :width 32
           :height 32}]]])
     [:> ch/Link
      {:href (when-not without-navigation? home-href)
       #_:on-click #_(fn [e]
                       (reset! expanded-atm true)
                       (.preventDefault e)
                       (if home-page?
                         (track "Header expanded" {})
                         (track "Logo clicked" {})))}
      [:> ch/Image
       {:src (:logo-image business-info)
        :max-width 132
        :max-height 50
        :fit :contain}]]

     [:& language-selector/lang-button {}]

     #_[:> ch/Icon
        {:as FaBars
         :font-size "24px"}]]))

(mf/defc wrapper [{:keys [children provider footer? no-wrapper? no-header-navigation?]}]
  (let [trackers (get-in provider [:provider/business-info :provider/trackers])
        theme-cfg (get-in provider [:provider/business-info :provider/theme-cfg])]
    (mf/with-effect
      [(hash trackers)]
      (tracking/init-trackers! trackers))
    [:*
     (when (:fonts-css-import theme-cfg)
       [:& fonts-import {:fonts-css-import (:fonts-css-import theme-cfg)}])
     [:> ch/ChakraProvider {:theme (theme theme-cfg)}
      (if no-wrapper?
        children
        [:> ch/Box
         {:bg "gray.50"
          :min-height "$100vh"}
         [:> ch/Container
          {:p 0
           :bg "white"
           :box-shadow "base"}
          (when provider
            [:& header-bar {:provider provider
                            :without-navigation? no-header-navigation?}])
          children]
         (when footer?
           [:& footer])])]]))

(mf/defc drawer [{:keys [is-open on-close children]}]
  [:> ch/Drawer
   {:is-open is-open
    :on-close on-close
    :placement :bottom}
   [:> ch/DrawerOverlay {}]
   [:> ch/DrawerContent
    {:border-top-radius "lg"
     :py 2}
    [:> ch/DrawerBody {}
     children]]])

(mf/defc info-modal-link [{:keys [label content]}]
  (let [open? (mf/use-state false)]
    [:*
     [:> ch/Text {:cursor :pointer :text-decoration :underline :on-click #(reset! open? true) :mb 2 :font-weight :medium}
      label]
     [:> ch/Modal
      {:isOpen @open?
       :on-close #(reset! open? false)}
      [:> ch/ModalOverlay {}]
      [:> ch/ModalContent {}
       [:> ch/ModalCloseButton {}]
       [:> ch/ModalBody {:text-align :center}
        content]
       [:> ch/ModalFooter {:justify-content :center}
        [:> ch/Button
         {:on-click #(reset! open? false)
          :size :lg
          :color-scheme :brand}
         "OK"]]]]]))

(mf/defc company-info-label [business-info]
  (let [{:keys [t]} (hooks/use-translation)]
    [:& info-modal-link
     {:label
      (mf/html
       [:span
        [:& iconify/Icon
         {:icon "material-symbols:info-rounded"
          :color "var(--chakra-colors-surface-primary-500)"
          :width 24
          :height 24
          :style #js {:display "inline-block" :verticalAlign "middle" :marginRight "8px"}}]
        (t :company-info-short)])
      :content
      (mf/html
       [:div
        [:> ch/Heading {:size :sm :my 4} (t :company-info)]
        (or (:legal-name business-info) (:name business-info)) [:br]
        (:address business-info) [:br]
        (when-let [nip (:nip business-info)]
          [:* (str "NIP: " nip) [:br]])
        (when-let [regon (:regon business-info)]
          [:* (str "REGON: " regon) [:br]])
        [:br]
        (when-let [phone (:phone business-info)]
          (when-let [email (:email business-info)]
            [:* (str phone) ", " (str email)]))
        (when-let [www-url (:www-url business-info)]
          [:> ch/Link {:href (str www-url)} (:www business-info)])])}]))

(mf/defc opening-hours [business-info]
  (let [{:keys [t]} (hooks/use-translation)
        opening-hours (:opening-hours business-info)
        format-hours (fn [[from to]]
                       (str (str (tick/time from))
                            " - "
                            (str (tick/time to))))]
    (when opening-hours
      [:& info-modal-link
       {:label
        (mf/html
         [:span
          [:& iconify/Icon
           {:icon "material-symbols:schedule-rounded"
            :color "var(--chakra-colors-surface-primary-500)"
            :width 24
            :height 24
            :style #js {:display "inline-block" :verticalAlign "middle" :marginRight "8px"}}]
          [:span
           (tick/format "EEE" (tick/today)) ", "
           (format-hours (get opening-hours (tick/int (tick/day-of-week))))]])
        :content
        (mf/html
         [:div
          [:> ch/Heading {:size :sm :my 4} (t :opening-hours)]
          [:> ch/Box {}]
          (for [[weekday hours] (sort-by first opening-hours)]
            [:> ch/Flex {:gap 6
                         :key (str weekday hours)}
             [:> ch/Text {:flex 1 :text-align :right} (string/capitalize (str (tick/day-of-week weekday)))]
             [:> ch/Text {:flex 1 :text-align :left}
              (format-hours hours)]])])}])))

;; todo: storage with one key per provider 
(def visited-providers (s/atom-with-session-storage "visited-p" #{}))

(mf/defc parallax-image-card [{:keys [image children top-space card-background]}]
  (let [{:keys [scrollY]} (->clj (fm/useViewportScroll))
        img-parallax (fm/useTransform scrollY #js [0 500] #js [0 100])]
    [:> ch/Box
     {:position :relative
      :pt (when image (str top-space "px"))
      :px "22px"
      :overflow :hidden}
     (when image
       [:> ch/Image
        {:src image
         :position :absolute
         :fit :cover
         :h "280px"
         :w :full
         :transform "scale(120%) translateY(-10%)"
         :object-position "50% 30%"
         :top 0
         :left 0
         :as fm/motion.img
         :style #js {:y img-parallax}}])
     [:> ch/Box
      {:border-top-radius "12px"
       :border-bottom-radius (when card-background "12px")
       :background (or card-background "white")
       :box-shadow (when image "sm")
       :p 3
       :position :relative}
      children]]))

(mf/defc provider-header
  {::mf/register components
   ::mf/register-as :provider-card}
  [{:keys [provider only-image provider-name-color]}]
  (let [{:keys [provider]} @(s/use-atom last-resolved-state)
        business-info (:provider/business-info provider)
        visited-p (s/use-atom visited-providers)
        first-time? (not (contains? @visited-p (:provider/id provider)))
        route (s/use-atom route-state)
        expanded? (not= "1" (:c @route)) ;(s/use-atom expanded-atm)
        t (hooks/use-t)]
    ; fixme, causes 2 renders
    #_(mf/with-effect
        (when first-time?
          (swap! visited-p conj (:provider/id provider))))
    [:> ch/Box {:mx -4 :mb 6}
     [:> ch/Collapse {:in expanded?}
      [:& parallax-image-card
       {:image (:background-image business-info)
        :top-space 176}

       [:> ch/Heading
        {:size :lg
         :font-weight :bold
         :text-align :center
         :color provider-name-color}
        (:name business-info)]
       [:> ch/Text {:font-size :md :text-align :center :font-family "Abhaya Libre" :mb 4} (:category business-info)]
       [:& company-info-label business-info]
       [:& opening-hours business-info]
       [:> ch/Text {:font-weight :medium}
        [:& iconify/Icon
         {:icon "material-symbols:location-on-rounded"
          :color "var(--chakra-colors-surface-primary-500)"
          :width 24
          :height 24
          :style #js {:display "inline-block" :verticalAlign "middle" :marginRight "8px"}}]
        (:address business-info)]]

      [:> ch/Box {:px 4 :py 6}
       [:> ch/Text
        {:text-align :center
         :sx {:textWrap :pretty}}
        (t (:description business-info))]]]]))

#_(defn toast-catcher [])

(mf/defc cmp-not-found [_]
  [:p "error, cmp not found"])

(defn load-lazy-cmp [component]
  (let [ns (namespace component)
        suffix (last (string/split ns #"\."))]
    (js/console.log "Loading " ns "=>" suffix)
    (try
      (-> (loader/load suffix)
          (.then
           (fn []
             (let [cmp (get @components component)]
               #js {:default cmp}))
           (fn []
             (js/console.error "Module loading error"))))
      (catch js/Error e
        (js/console.error "Module loading error")
        (js/Promise.resolve
         #js{:default cmp-not-found})))))

(defn render-cmp [{:keys [app/component] :as desc}]
  ;(js/console.log "render-cmp" desc)
  (when component
    (if-let [cmp (get @components component)]
      (mf/html [:& cmp desc])
      (if (namespace component)
        (mf/html
         [:> react/Suspense {}
          (mf/element
           (react/lazy #(load-lazy-cmp component))
           desc)])
        (mf/html [:p "error, cmp " (pr-str component) " not found"])))))

(mf/defc loading
  {::mf/register components}
  [_]
  (let [{:keys [t]} (hooks/use-translation)]
    [:> ch/Box
     {:pt 100}
     [:> ch/Center {}
      [:> ch/Box {:text-align :center}
       [:> ch/Spinner {:size :xl}]
       [:> ch/Text {}
        (t :loading)]]]]))

(mf/defc not-found
  {::mf/register components}
  []
  (let [{:keys [t]} (hooks/use-translation)]
    [:> ch/Box
     {:pt 100}
     [:> ch/Center {}
      [:> ch/Box {:text-align :center}
       [:> ch/Image {:src "/img/logo.png" :width 200}]
       [:> ch/Text {}
        (t :NotFoundScreenError)]]]]))

(mf/defc image-parallax
  {::mf/register components
   ::mf/register-as :image-parallax}
  [{:keys [image content]}]
  [:> ch/Box
   {:mx -4}
   [:& parallax-image-card
    {:image image
     :top-space 182
     :card-background "var(--chakra-colors-surface-secondary-200)"}
    (for [x content]
      (when x
        [:* {:key (hash x)}
         (render-cmp x)]))]])

(def transitions
  {:init {:initial {:opacity 0}
          :animate {:opacity 1}
          :exit {:opacity 0}}
   :forward
   {:initial {:x 600 :opacity 1}
    :animate {:x 0 :opacity 1}
    :exit {:x 0 :opacity 0}}
   :back
   {:initial {:opacity 0}
    :animate {:opacity 1}
    :exit {:opacity 0}}
   :bottom
   {:initial {:y 1000 :opacity 1}
    :animate {:y 0 :opacity 1}
    :exit {:y 1000 :opacity 0}}
   ;:top
   #_{:initial {:y -1000}
      :animate {:y 0}
      :exit {:y 0}}})

(mf/defc screen []
  (let [state (s/use-atom last-resolved-state)
        route-state @(s/use-atom route-state)
        key (hash (dissoc route-state :c :transition))
        transition (get transitions (:transition route-state))]
    [:& wrapper
     {:provider (:provider @state)
      :footer? (get-in @state [:app/show-footer])
      :no-wrapper? (get-in @state [:app/no-wrapper?])
      :no-header-navigation? (get-in @state [:app/no-header-navigation?])}
     [:> react/Suspense {}
      [:& with-last-resolved-state {}]]
     [:> ch/Box {:overflow-x :clip
                 :position :relative}
      [:> fm/AnimatePresence
       {:initial false
        :mode "wait" ;popLayout
        :onExitComplete (fn [] (js/window.scrollTo 0 0))}
       [:> fm/motion.div
        {:style #js {:background "white"}
         :key key
         :transition {:ease "linear" :duration 0.2}
         :initial (clj->js (:initial transition))
         :animate (clj->js (:animate transition))
         :exit (clj->js (:exit transition))}

        (when @state
          (render-cmp @state))]]]]))
